import { Box, Grid2, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import { AudioStartCard } from '../AudioStartCard';
import InstructionCard from '../InstructionCard';
import { leftPanelStyles } from './styles';

interface LeftPanelProps {
  isSbConnect?: boolean;
}

const LeftPanel: React.FC<LeftPanelProps> = ({ isSbConnect = false }) => {
  const [instructionsOpen, setInstructionsOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const collapsible = !isDesktop; // collapse only on tablet/mobile
  const showHero = isDesktop || instructionsOpen;
  return (
    <Grid2
      size={{ xs: 12, lg: isSbConnect ? 8 : 6 }}
      sx={{
        ...leftPanelStyles.container,
        mx: { lg: isSbConnect ? 'auto' : 'initial' },
      }}
    >
      {showHero && (
        <Box sx={leftPanelStyles.titleSection}>
          <Typography variant="h1" sx={leftPanelStyles.title}>
            Create clinically formatted &<br />
            structured notes
          </Typography>
          <Typography variant="h2" sx={leftPanelStyles.subtitle}>
            with justified coding in real time as you speak.
          </Typography>
        </Box>
      )}

      <InstructionCard
        title={collapsible ? 'Close instructions' : 'Recording exam is simple:'}
        collapsedTitle={
          collapsible ? 'Open instructions how to use' : undefined
        }
        contentTitle={collapsible ? 'Recording exam is simple:' : undefined}
        instructions={[
          {
            text: 'Click green "play" button to start',
            type: 'green',
          },
          {
            text: 'Click "End Recording" followed by "Get Note" to create note',
            type: 'purple',
          },
        ]}
        collapsible={collapsible}
        defaultOpen={isSbConnect || !collapsible}
        onOpenChange={collapsible ? setInstructionsOpen : undefined}
      />

      {/* On desktop, render the Audio card within the left column to avoid large cross-column gaps */}
      {isDesktop && (
        <AudioStartCard
          title="Our A.I. will generate your SOAP note"
          subtitle="You auto-paste it into your EHR"
          allowParallelRecording={isSbConnect}
        />
      )}
    </Grid2>
  );
};

export default LeftPanel;
